import React, { useEffect, useState } from "react";
import "./ScoreBoard.css";

const ScoreBoard = ({ players, currentPlayer }) => {
	// Track animated players (who recently gained points)
	const [animatedPlayers, setAnimatedPlayers] = useState({});

	useEffect(() => {
		const newAnimatedPlayers = {};

		players.forEach((player) => {
			const prevScore = animatedPlayers[player.pseudo]?.score || 0;

			// If the score increased, trigger the animation
			if (player.score > prevScore) {
				newAnimatedPlayers[player.pseudo] = {
					score: player.score,
					animate: true,
				};

				// Remove animation after 1 second
				setTimeout(() => {
					setAnimatedPlayers((prev) => ({
						...prev,
						[player.pseudo]: { score: player.score, animate: false },
					}));
				}, 1000);
			} else {
				// Keep the latest score without animation
				newAnimatedPlayers[player.pseudo] = {
					score: player.score,
					animate: false,
				};
			}
		});

		setAnimatedPlayers(newAnimatedPlayers);
	}, [players]);

	return (
		<div className="flex flex-col items-start bg-white p-4 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)]">
			<h3 className="mb-2">Classement:</h3>
			<ul>
				{[...players]
					.sort((a, b) => (b.score || 0) - (a.score || 0)) // Sort players by score (descending)
					.map((player) => (
						<li
							key={player.pseudo}
							className={`px-2 text-sm border-b flex items-center transition-all duration-500 ease-out ${
								player.pseudo === currentPlayer?.pseudo
									? "font-bold text-orange-500"
									: ""
							}`}
						>
							<span>{player.pseudo} - </span>
							<span
								className={`ml-2 ${
									animatedPlayers[player.pseudo]?.animate ? "score-up" : ""
								}`}
							>
								{player.score || 0} pts
							</span>
						</li>
					))}
			</ul>
		</div>
	);
};

export default ScoreBoard;
